import * as oauth from 'oauth4webapi';

import { AuthConfig } from '../SciFinderAuthProvider';

export async function fetchSSOServerMetadata(authConfig: AuthConfig) {
  const SSO_BASE_URL = new URL(authConfig.ssoBaseUrl);

  const response = await oauth.discoveryRequest(SSO_BASE_URL);
  return oauth.processDiscoveryResponse(SSO_BASE_URL, response);
}

export async function getClient(authConfig: AuthConfig): Promise<oauth.Client> {
  const CLIENT_ID = authConfig.clientId;

  return {
    client_id: CLIENT_ID,
    token_endpoint_auth_method: 'none',
  };
}
